import { createTheme } from '@mui/material/styles';
import { accent, darkTokens, fontFamily, lightTokens } from './tokens';

export const createAppTheme = (mode = 'light') => {
  const t = mode === 'dark' ? darkTokens : lightTokens;
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: isDark ? accent.main : lightTokens.ctaBg,
        light: isDark ? '#f39c4d' : '#1a4060',
        dark: isDark ? accent.dark : lightTokens.ctaBgHover,
        contrastText: t.ctaFg
      },
      secondary: {
        main: accent.main,
        dark: accent.dark,
        contrastText: '#ffffff'
      },
      background: {
        default: t.bg,
        paper: t.surface
      },
      text: {
        primary: t.fg,
        secondary: t.ink70
      },
      divider: t.border,
      success: {
        main: isDark ? darkTokens.pillDriftFg : lightTokens.pillDriftFg
      }
    },
    typography: {
      fontFamily,
      h4: { fontWeight: 700, letterSpacing: '-0.5px' },
      h6: { fontWeight: 600 }
    },
    shape: {
      borderRadius: 8
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: t.bg,
            color: t.fg
          }
        }
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: t.navBg,
            color: t.fg,
            backdropFilter: 'blur(12px)',
            borderBottom: `1px solid ${t.border}`,
            boxShadow: 'none'
          }
        }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: `0 2px 8px ${t.cardShadow}`,
            border: `1px solid ${t.border}`
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: 100,
            fontWeight: 600
          },
          containedPrimary: {
            backgroundColor: t.ctaBg,
            color: t.ctaFg,
            '&:hover': {
              backgroundColor: t.ctaBgHover
            }
          }
        }
      },
      MuiChip: {
        styleOverrides: {
          root: {
            fontWeight: 600
          }
        }
      }
    }
  });
};
